<template>
  <v-dialog v-model="dialog" persistent max-width="600" v-if="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col> Finalizar a Análise </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('close')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <template v-if="itens.perguntaFaixaRespostaId">
          <v-row>
            <v-col>
              <h2 class="info-modal">
                É obrigatório o preenchimento da pontuação alcançada
                para esse critério.
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-form v-model="valid" lazy-validation>
                <combobox-faixa
                  ref="faixa"
                  :perguntaFaixaId="itens.perguntaFaixaRespostaId"
                  :filter="filter"
                  :rules="rules"
                ></combobox-faixa>
              </v-form>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col>
            <h2 class="info-modal">
              Ao finalizar a análise, as aprovações e rejeições não poderão ser
              revertidas.
            </h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" @click="$emit('close')">Cancelar</v-btn>
        <v-btn color="azulclarosc" style="color: #fff" @click="finalizar"
          >Finalizar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxFaixa from "./ComboboxFaixa.vue";

export default {
  components: { ComboboxFaixa },
  name: "ModalFinaliarEvidencias",
  props: {
    dialog: false,
    itens: {},
  },
  data() {
    return {
      filter: { faixaId: {} },
      rules: [
        (v) => {
          if (v > 0) {
            return true;
          }

          return "Campo Obrigatório";
        },
      ],
      valid: false,
    };
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    async finalizar() {
      if (this.$refs.faixa) {
        const valid = await this.$refs.faixa.isValid();

        if (valid) {
          this.$emit("finalizar", this.filter);
        }
        return;
      }
      this.$emit("finalizar", { faixaId: null });
    },
  },
};
</script>
<style lang="scss" scoped>
.info-modal {
  color: #000;
  font-size: 16px;
  font-weight: 400;
}
</style>
